<template>
    <common-modal>
        <common-page-plain>
            <common-content-wrapper width="medium">
                <common-content-spacer height="medium">
                    <common-warning :message="$t('modals.out_of_availability_modal.warning')"></common-warning>
                    <div>
                        <div v-for="offer in offers" :key="offer.id" class="out-of-availability__item">
                            <b>
                                {{
                                    $t('modals.out_of_availability_modal.offer_name', {
                                        name: offer.titleTextContent.originalText,
                                    })
                                }}
                            </b>
                            <div>
                                {{
                                    $t('modals.out_of_availability_modal.number_rescheduled_reservations', {
                                        n: offer.affectedCalendarEvents,
                                    })
                                }}
                            </div>
                            <hr />
                        </div>
                    </div>
                    <common-page-header
                        size="small"
                        :heading="$t('modals.out_of_availability_modal.falling_out')"
                        :isCenter="true"
                    ></common-page-header>

                    <common-buttons>
                        <common-button
                            type="secondary"
                            :label="$t('common.microcopy.false')"
                            @click="emitEvent({ name: 'close' })"
                        ></common-button>
                        <common-button
                            type="primary"
                            :label="$t('common.microcopy.true')"
                            @click="emitEvent({ name: 'accepted' })"
                        ></common-button>
                    </common-buttons>
                </common-content-spacer>
            </common-content-wrapper>
        </common-page-plain>
    </common-modal>
</template>

<script>
    export default {
        props: {
            offers: { type: Array, required: true },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';

    .out-of-availability__item {
        height: 80px;
        color: $color--txt-header;
    }
</style>
